<div class="image-banner-container">
  <section
    class="image-banner-bg"
    [ngClass]="{
      'image-banner-neutral': block.data.backgroundColor === 'neutral',
      'image-banner-primary': block.data.backgroundColor === 'primary',
    }"
  ></section>
  <div
    class="image-banner__panel image-banner__panel--img"
    [ngClass]="'image-banner-' + block.data.imageWidth"
  >
    <img class="image-banner__panel-img" [src]="imageUrl" alt="TODO" />
  </div>
</div>
